import { Col, Row } from 'antd'
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import GraphDetails from './GraphDetails'
import {
  CustomLegend,
  CustomLegendLabelRow,
  ShadowBoxSubTitle,
  ShadowBoxTitle,
} from './StyledComponent'

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend)

export default function DonutWithCustomLegend({
  label = [],
  labelValues = [],
  backgroundColor = [],
  title,
  description,
  legend = false,
  legendOnly = false,
  graphRef,
  currentData,
  legendRow,
  onlyChart,
  type,
  state,
  setCtcSelected,
  setIsCTCCategory,
  donutType,
  isDownload,
}) {
  const [selectedRole, setSelectedRole] = useState(null)
  const [hideSelectedRole, setHideSelectedRole] = useState(null)

  useEffect(() => {
    setHideSelectedRole(selectedRole)
    if (isDownload) {
      setSelectedRole(null)
    } else {
      setSelectedRole(hideSelectedRole)
    }
  }, [isDownload])
  const data = {
    labels: label,
    datasets: [
      {
        data: labelValues,
        backgroundColor: backgroundColor,
        borderWidth: 0, // Remove border width between segments
      },
    ],
  }

  const options = {
    maintainAspectRatio: true, // Ensures the chart maintains its aspect ratio
    responsive: true, // Makes the chart responsive
    plugins: {
      legend: {
        display: false, // Display legend for labels
      },
      tooltip: {
        enabled: false,
      },
    },
    onHover: (event, elements) => {
      const target = event.native.target
      if (target) {
        target.style.cursor = elements?.length > 0 ? 'pointer' : 'default'
      }
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index
        handleClick(label[index], labelValues[index])
      }
    },
  }

  const handleClick = (label, value) => {
    const found = currentData?.find(item => item?.label == label)
    console.log(found)
    // Rename key 'other' to 'others' if present
    const sanitized = found && Object.prototype.hasOwnProperty.call(found, 'other')
      ? (() => {
          const { other, ...rest } = found
          return { ...rest, others: other }
        })()
      : found
    setSelectedRole({
      label: label,
      value,
      ...sanitized,
    })
    if (setCtcSelected && donutType == 'ctcAnalysis') {
      setCtcSelected(true)
    }
    if (donutType == 'ctcCategory') {
      setIsCTCCategory(true)
    }
  }

  const renderCustomLegend = chart => {
    const labels = chart.labels
    const backgroundColors = chart.datasets[0].backgroundColor
    const values = chart.datasets[0].data

    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '20px',
          }}
        >
          <Row>
            {labels?.map((item, index) => {
              return (
                <Col
                  md={legendRow ? legendRow : 8}
                  xs={24}
                  lg={legendRow ? legendRow : 8}
                  sm={legendRow ? legendRow : 8}
                  key={index + item}
                  onClick={() => handleClick(label[index], values[index])}
                  style={{ cursor: 'pointer' }}
                >
                  <Row
                    align={'middle'}
                    style={{ marginBottom: 10, flexWrap: 'nowrap' }}
                  >
                    <Col>
                      <CustomLegend color={backgroundColors[index]} />
                    </Col>
                    <Col>
                      <Row
                        style={{
                          flexDirection: 'column',
                        }}
                      >
                        <CustomLegendLabelRow
                          weight={800}
                          active={label[index] == selectedRole?.label}
                        >
                          {values[index].endsWith('%')
                            ? values[index]
                            : values[index] + '%'}
                        </CustomLegendLabelRow>
                        <CustomLegendLabelRow
                          weight={
                            label[index] == selectedRole?.label ? 800 : 500
                          }
                          active={label[index] == selectedRole?.label}
                        >
                          {/* {label[index]} */}
                          {labels[index]?.includes(' - ')
                            ? labels[index].split(' - ')[0] ===
                              labels[index].split(' - ')[1]
                              ? labels[index].split(' - ')[0]
                              : labels[index]
                            : labels[index]}
                        </CustomLegendLabelRow>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )
            })}
          </Row>
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (setSelectedRole) setSelectedRole(null)
  }, [state?.selectedCategory])

  const handleClearClick = () => {
    setSelectedRole(null)
    // if (donutType == 'ctcAnalysis' && setCtcSelected) {
    //   setCtcSelected(false)
    //   setIsCTCCategory(false)
    // }
  }

  return (
    <div style={{ height: '100%' }}>
      <ShadowBoxTitle>{title}</ShadowBoxTitle>
      <ShadowBoxSubTitle>{description}</ShadowBoxSubTitle>
      {!legendOnly ? (
        <Row align="middle" gutter={10} style={{ flexWrap: 'nowrap' }}>
          <Col>
            <div style={{ height: 230, width: 230 }} ref={graphRef}>
              <Doughnut data={data} options={options} />
            </div>
          </Col>
          {!onlyChart && (
            <Col flex={1}>
              <div>{renderCustomLegend(data)}</div>
            </Col>
          )}
        </Row>
      ) : (
        <div
          style={{ display: 'flex', justifyContent: 'space-between' }}
          ref={graphRef}
        >
          {label.map((item, index) => (
            <div
              key={index + 'legendOnly'}
              onClick={() =>
                !currentData[index]?.disable &&
                handleClick(item, labelValues[index])
              }
              style={{
                cursor: currentData[index]?.disable ? 'not-allowed' : 'pointer',
                pointerEvents: currentData[index]?.disable ? 'none' : 'unset',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <CustomLegend
                color={backgroundColor[index]}
                width={'70px'}
                height={'70px'}
                borderRadius={'70px'}
                marginRight={'0px'}
              />
              <CustomLegendLabelRow
                active={item == selectedRole?.label}
                textAlign={'center'}
                weight={800}
              >
                {item}
              </CustomLegendLabelRow>
              <CustomLegendLabelRow
                weight={item == selectedRole?.label ? 800 : 500}
                active={item == selectedRole?.label}
                textAlign={'center'}
              >
                {labelValues[index]}
              </CustomLegendLabelRow>
            </div>
          ))}
        </div>
      )}
      {legend && (
        <GraphDetails
          data={selectedRole}
          setData={setSelectedRole}
          type={type}
          handleClearClick={handleClearClick}
          donutType={donutType === 'ctcCategory'}
          placement={state?.selectedCategory === 'PLACEMENT'}
        />
      )}
    </div>
  )
}
